export default __webpack_public_path__ + "static/media/spheres.9083d0a8.mp3";